/**
 * @generated SignedSource<<c27072b219a497789dcd2a1eef29858d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type DeleteValveConnectorInput = {
  valveConnectorId: string;
  clientMutationId?: string | null;
};
export type ValveConnectorsTableDeleteValveConnectorMutation$variables = {
  input: DeleteValveConnectorInput;
};
export type ValveConnectorsTableDeleteValveConnectorMutationVariables = ValveConnectorsTableDeleteValveConnectorMutation$variables;
export type ValveConnectorsTableDeleteValveConnectorMutation$data = {
  readonly deleteValveConnector: {
    readonly valveConnector: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly message: string;
    }>;
  } | null;
};
export type ValveConnectorsTableDeleteValveConnectorMutationResponse = ValveConnectorsTableDeleteValveConnectorMutation$data;
export type ValveConnectorsTableDeleteValveConnectorMutation = {
  variables: ValveConnectorsTableDeleteValveConnectorMutationVariables;
  response: ValveConnectorsTableDeleteValveConnectorMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteValveConnectorPayload",
    "kind": "LinkedField",
    "name": "deleteValveConnector",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValveConnector",
        "kind": "LinkedField",
        "name": "valveConnector",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValveConnectorsTableDeleteValveConnectorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValveConnectorsTableDeleteValveConnectorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "14f7d0b68638ff3b38d9afab7f5f0aa1",
    "id": null,
    "metadata": {},
    "name": "ValveConnectorsTableDeleteValveConnectorMutation",
    "operationKind": "mutation",
    "text": "mutation ValveConnectorsTableDeleteValveConnectorMutation(\n  $input: DeleteValveConnectorInput!\n) {\n  deleteValveConnector(input: $input) {\n    valveConnector {\n      id\n      name\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c9622f3f0b7dc746043be66ff9b63f76";

export default node;
